/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @group Constants
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 * 
 * @example
 * ```typescript
 * import { VIEW_RESOURCES } from '@shared/utils';
 * 
 * // Use view resource constants
 * const resource = VIEW_RESOURCES.HOME;
 * ```
 */
export const VIEW_RESOURCES = {
  MOBILE_APP_FORCE_UPDATE: 'mobile.app.force-update',
  MOBILE_APP_HOME_INDEX: 'mobile.app.home.index',
  MOBILE_APP_MEDICAL_RECORDS_INDEX: 'mobile.app.medical-records.index',
  MOBILE_APP_PROFILE_ABOUT: 'mobile.app.profile.about',
  MOBILE_APP_PROFILE_INDEX: 'mobile.app.profile.index',
  MOBILE_APP_PROFILE_PATIENT_DETAILS: 'mobile.app.profile.patient-details',
  MOBILE_APP_PROFILE_PAYMENT_METHODS: 'mobile.app.profile.payment-methods',
  MOBILE_APP_USERS_SIGNIN: 'mobile.app.users.signin',
  MOBILE_APP_WAITING_ROOM: 'mobile.app.waiting-room',
  MOBILE_APP_WAITING_ROOM_ACTIVE: 'mobile.app.waiting-room.active',
} as const;